export default {
  ui: {
    fields: [
      'key',
      'date',
      'status',
      'salesPerson',
      'summary',
      'amount',
      'payType',
      'consumer.id',
      'consumer.name',
      'note',
    ],
  },
  populations: 'consumers,staffers',
}
